"use client";

import type { CarouselApi } from "@workspace/frontend-ui";
import { useCallback, useEffect, useState } from "react";

const useHeroCarousel = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }
    const syncSelected = () => {
      setSelectedIndex(api.selectedScrollSnap());
      setProgress(0);
    };
    syncSelected();
    api.on("select", syncSelected);
    return () => {
      api.off("select", syncSelected);
    };
  }, [api]);

  const handleComplete = useCallback(() => {
    api?.scrollNext();
  }, [api]);

  const handleSelect = useCallback(
    (index: number) => {
      api?.scrollTo(index);
    },
    [api],
  );

  return {
    setApi,
    selectedIndex,
    progress,
    setProgress,
    handleComplete,
    handleSelect,
  };
};

export default useHeroCarousel;
